import React from 'react';
import './../../styles/VideoModal.css';

function VideoModal({ videoUrl, isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="video-modal-overlay">
      <div className="video-modal-content">
        <button className="video-modal-close-button" onClick={onClose}>
          &times;
        </button>
        <video controls style={{ width: '100%', maxHeight: '80vh', borderRadius: '8px' }}>
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export default VideoModal;
